import { useUpdateCadRunInfo } from '@hooks/useUpdateCADJob';
import { useQueryClient } from '@tanstack/react-query';

export const useCancelCadJob = () => {
  const queryClient = useQueryClient();

  const { mutateAsync: updateCadRunInfo } = useUpdateCadRunInfo();

  const cancelJob = async (runID: string, accountId: string) => {
    await updateCadRunInfo({ runID: runID!, accountId, status: 'CANCELLED_BY_USER' });

    await queryClient.invalidateQueries(['getCadRunInfo', runID]);
    await queryClient.invalidateQueries(['productList']);

    /*
     * react-query client has refetchOnMount=false set (which it shouldn't)
     * so we have to explicitly refetch the now stale productList query so
     * the Product List page will not show this cancelled job
     */
    await queryClient.refetchQueries({ queryKey: ['productList'], type: 'active' });
  };

  return { cancelJob };
};
